const jobs = [
  {
    id: "chl",
    date: "11/2019 to 12/2021",
    company: "CHL Mortgages",
    role: "Arrears Operations Specialist",
    duties: [
      "Engaged in telephone communications with customers to address account arrears and resolve associated inquiries.",
      "Processed payments for delinquent accounts and conducted financial analysis to work out repayment strategies.",
    ],
  },
  {
    id: "metro3",
    date: "02/2018 to 10/2019",
    company: "Metro Bank",
    role: "Customer Service Representative",
    duties: [
      "Onboarded new personal and business customers, administered lending services and dealt with queries, customer service duties and ATM balancing.",
    ],
  },
  {
    id: "metro2",
    date: "10/2017 to 02/2018 ",
    company: "Metro Bank",
    role: "Lead Cashier",
    duties: [
      "Enhanced cashier performance through observational assessments and coaching sessions.",
    ],
  },
  {
    id: "metro1",
    date: "10/2016 to 10/2017 ",
    company: "Metro Bank",
    role: "Cashier",
    duties: [
      "Addressed customer queries, managed cash transactions and provided training to onboard new staff.",
    ],
  },
  {
    id: "river",
    date: "11/2015 to 10/2016",
    company: "River Island",
    role: "Retail sales assistant",
    duties: [
      "Managed customer inquiries and executed financial transactions.",
    ],
  },
];

export default jobs;
